import { useNavigate, useParams } from "react-router-dom";
import ReusableTable from "../../ReusableTable/ReusableTable";
import { env } from "../../../constants/env";
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import { fetchCertificationSummary } from "../../../utils/offlineFetchCertifications";

const OrganizationLeadership = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const { user } = useAuth();
  const userRole = user?.role;

  const { labId } = useParams(); // Replace with actual lab ID (from context, props, or auth)
  const name = "SLIPTA";
  const section = "Organization & Leadership";

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchCertificationSummary({
        labId,
        name: "SLIPTA",
        section, // or "Documents & Records"
      });
      setTableData(data);
    };

    if (labId) loadData();
  }, [labId, , name, section]);

  const sectionColumns = [
    { label: "Title", field: "title" },
    { label: "Total Score", field: "totalScore" },
    { label: "Created", field: "created" },
    { label: "Updated", field: "updated" },
    { label: "Status", field: "status" },
  ];
  return (
    <div>
      <ReusableTable
        title="Organization & leadership"
        showTopAdd={userRole === "ASSESSOR" ? tableData.length > 0 : false}
        columns={sectionColumns}
        data={tableData}
        onAdd={
          userRole === "ASSESSOR"
            ? () => navigate("add-organization-leadership")
            : false
        }
        showDetails={false}
        onEdit={
          (row) => {
            if (row.status === "Attached") {
              toast.error("Can not edit as document is already attached");
            } else {
              navigate(`add-organization-leadership/${row.id}`);
            }
          } // edit mode
        }
      />
    </div>
  );
};

export default OrganizationLeadership;
